import React, {memo} from "react";
import {Box} from "@mui/material";
import { styled } from "@mui/material/styles";

const PSIcon = ({ name, network, width, height, margin = "0 12px" }) => {

  const Icon = styled(Box)(({ theme }) => ({
    width,
    height,
    margin,
    minWidth: width,
    position: "relative",
    display: "inline-block",
    "& > img": {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      maxHeight: "100%",
      width: "100%",
      height: "auto"
    },
  }));

  const postfixShort = {
    "BEP2": "bep",
    "BEP20": "bep",
    "ERC20": "erc",
    "TRC20": "trc",
    "OMNI": "omni"
  };
  
  const systemUseNets = ["tethernew", 'usdcoin', "ethereum"];

  var type = "color";
  var postfix = ""

  if (network && systemUseNets.includes(name.toLowerCase())) {
    type = "network";
    postfix = "_" + (postfixShort[network] || network.toLowerCase())
  }

  return (
    <Icon>
      {name
        ? <img src={`/psicons/${type}/${name.toLowerCase()}${postfix}.svg`} crossOrigin="anonymous"/>
        : <img src={`/psicons/color/bitcoin.svg`} crossOrigin="anonymous"/>
      }
    </Icon>
  );
};

export default memo(PSIcon);
//export default PSIcon;
